import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import HomePage from './pages/HomePage';
import ProgramsPage from './pages/ProgramsPage';
import ProgramDetail from './pages/ProgramDetail';
import KafalaOrphelinPublic from './pages/KafalaOrphelinPublic';
import StatsPage from './pages/StatsPage';
import AboutPage from './pages/AboutPage';
import DossiersPage from './pages/DossiersPage';
import ProjetDetail from './pages/ProjetDetail';
import DonatePage from './pages/DonatePage';
import VolunteerPage from './pages/VolunteerPage';
import ActualitesPage from './pages/ActualitesPage';
import ActualiteDetail from './pages/ActualiteDetail';
import LegalPage from './pages/LegalPage';
import PublicLocaleLayout from './routes/PublicLocaleLayout';
import LegacyPublicRedirect from './routes/LegacyPublicRedirect';
import { LocaleRedirect, PreferredLocaleRedirect } from './routes/LocaleRedirect';
import './App.css';

const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const OperateurDashboard = lazy(() => import('./pages/OperateurDashboard'));
const MaitresseDashboard = lazy(() => import('./pages/MaitresseDashboard'));
const DonateurRoutes = lazy(() => import('./routes/DonateurRoutes'));
const OrphelinDetail = lazy(() => import('./components/OrphelinDetail'));

const PageLoader = () => (
  <div className="app-route-loader" role="status" aria-live="polite">
    Chargement...
  </div>
);

const withPrivateSuspense = (element) => (
  <PrivateRoute>
    <Suspense fallback={<PageLoader />}>{element}</Suspense>
  </PrivateRoute>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<PreferredLocaleRedirect />} />

          <Route path="/:locale" element={<PublicLocaleLayout />}>
            <Route index element={<HomePage />} />
            <Route path="programmes" element={<ProgramsPage />} />
            <Route path="programmes/imaar" element={<LocaleRedirect to="/programmes/ramadan" />} />
            <Route path="programmes/ihyaa" element={<LocaleRedirect to="/programmes/adahi" />} />
            <Route path="programmes/kafala/orphelins/:id" element={<KafalaOrphelinPublic />} />
            <Route path="programmes/:slug" element={<ProgramDetail />} />
            <Route path="stats" element={<StatsPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="projets/:slug" element={<ProjetDetail />} />
            <Route path="dossiers" element={<DossiersPage />} />
            <Route path="donate" element={<DonatePage />} />
            <Route path="volunteer" element={<VolunteerPage />} />
            <Route path="actualites" element={<ActualitesPage />} />
            <Route path="actualites/:id" element={<ActualiteDetail />} />
            <Route path="legal" element={<LegalPage />} />
            <Route path="*" element={<LocaleRedirect to="/" />} />
          </Route>

          <Route path="/programmes" element={<PreferredLocaleRedirect path="/programmes" />} />
          <Route path="/programmes/:slug" element={<LegacyPublicRedirect template="/programmes/:slug" />} />
          <Route path="/stats" element={<PreferredLocaleRedirect path="/stats" />} />
          <Route path="/about" element={<PreferredLocaleRedirect path="/about" />} />
          <Route path="/projets/:slug" element={<LegacyPublicRedirect template="/projets/:slug" />} />
          <Route path="/dossiers" element={<PreferredLocaleRedirect path="/dossiers" />} />
          <Route path="/donate" element={<PreferredLocaleRedirect path="/donate" />} />
          <Route path="/volunteer" element={<PreferredLocaleRedirect path="/volunteer" />} />
          <Route path="/actualites" element={<PreferredLocaleRedirect path="/actualites" />} />
          <Route path="/actualites/:id" element={<LegacyPublicRedirect template="/actualites/:id" />} />
          <Route path="/legal" element={<PreferredLocaleRedirect path="/legal" />} />

          <Route path="/login" element={<Login />} />

          <Route path="/admin/*" element={withPrivateSuspense(<AdminDashboard />)} />
          <Route path="/operateur/*" element={withPrivateSuspense(<OperateurDashboard />)} />
          <Route path="/maitresse/*" element={withPrivateSuspense(<MaitresseDashboard />)} />
          <Route path="/donateur/*" element={withPrivateSuspense(<DonateurRoutes />)} />
          <Route path="/orphelin/:id" element={withPrivateSuspense(<OrphelinDetail />)} />

          <Route path="*" element={<PreferredLocaleRedirect />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
